<template>
  <!--  只允许一个 组件 -->
  <a-layout style="padding-top: 65px;">
    <!--中间布局-->
    <a-layout>

      <a-tabs v-model:activeKey="activeKey" type="card" style="margin-top: 0px;">

        <!-- 推荐文章列表 -->
        <a-tab-pane key="1" tab="推荐文章">

          <!-- 查询&新增-->
          <a-layout style="margin: 0px 0px 5px 10px">
            <a-form layout="inline" :model="param">
              <a-form-item>
                <a-button type="primary" @click="handleQueryArticle({ page: 1, size: pagination.pageSize })">
                  查询
                </a-button>
              </a-form-item>
            </a-form>
          </a-layout>

          <!--中间详文章列表-->
          <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }">
            <!--文章列表 -->
            <a-table :columns="columns" :data-source="articles" :pagination="pagination" :loading="loading"
              @change="handleTableChange">
              <template v-slot:bodyCell="{ column, record }">
                <!-- 注意：如果设置了v-slot:bodyCell，所有column都会“进入”到插槽，需在插槽内自行过滤掉不使用插槽的情况。` -->
                <template v-if="column.dataIndex === 'sort'">
                  {{ record.sort }}
                </template>
                <template v-if="column.dataIndex === 'coverUrl'">
                  <a-image v-if="record.articleVO.coverUrl" :width="52" :preview="true" :src="record.articleVO.coverUrl"
                    alt="avatar" />
                </template>
                <template v-if="column.dataIndex === 'title'">
                  {{ record.articleVO.title }}
                </template>
                <template v-if="column.dataIndex === 'category'">
                  <span>{{ record.articleVO.category1.name }} / {{ record.articleVO.category2.name }}</span>
                </template>
                <template v-if="column.dataIndex === 'description'">
                  {{ record.articleVO.description }}
                </template>
                <!-- <template v-if="column.dataIndex === 'summary'">
                  {{ record.articleVO.summary }}
                </template> -->
                <template v-if="column.dataIndex === 'viewCount'">
                  {{ record.articleVO.viewCount }}
                </template>
                <template v-if="column.dataIndex === 'voteCount'">
                  {{ record.articleVO.voteCount }}
                </template>
                <template v-if="column.dataIndex === 'status'">
                  <a-tag v-if="record.articleVO.status == 0" color="orange">未发布</a-tag>
                  <a-tag v-else-if="record.articleVO.status == 1" color="green">已发布</a-tag>
                </template>
                <template v-if="column.dataIndex === 'action'">
                  <a-space size="small">
                    <!-- 新页面打开 -->
                    <!-- 代码编码 window.open(routeUrl.href, '_blank'); -->
                    <router-link :to="'/doc?articleId=' + record.articleId" slots="a" target="_blank">
                      <a-button type="primary">
                        预览
                      </a-button>
                    </router-link>
                    <a-button type="primary" @click="editArticle(record)">
                      编辑
                    </a-button>
                    <!-- 删除 -->
                    <a-popconfirm title="删除后不可恢复，确认删除?" ok-text="是" cancel-text="否" @confirm="handleDelete(record.id)">
                      <a-button type="primary" danger>
                        删除
                      </a-button>
                    </a-popconfirm>
                  </a-space>
                </template>
              </template>
            </a-table>

          </a-layout-content>

        </a-tab-pane>

        <!-- 轮播图 -->
        <a-tab-pane key="2" tab="轮播图">

          <!-- 查询&新增-->
          <a-layout style="margin: 0px 0px 5px 10px">
            <a-form layout="inline" :model="param">
              <a-form-item>
                <a-button type="primary" @click="addBanner">
                  增加
                </a-button>
              </a-form-item>
              <a-form-item>
                <a-button type="primary" @click="handleQueryBanner({ page: 1, size: pagination.pageSize })">
                  查询
                </a-button>
              </a-form-item>
            </a-form>
          </a-layout>

          <!--中间轮播图列表-->
          <a-layout-content :style="{ background: '#fff', padding: '24px', margin: 0, minHeight: '280px' }">
            <!--文章列表 -->
            <a-table :columns="columnsBanner" :data-source="banners" :pagination="paginationBanner" :loading="loading"
              @change="handleBannerTableChange">
              <template v-slot:bodyCell="{ column, record }">
                <!-- 注意：如果设置了v-slot:bodyCell，所有column都会“进入”到插槽，需在插槽内自行过滤掉不使用插槽的情况。` -->
                <template v-if="column.dataIndex === 'sort'">
                  {{ record.sort }}
                </template>
                <template v-if="column.dataIndex === 'bannerUrl'">
                  <a-image v-if="record.bannerUrl" :width="52" :preview="true" :src="record.bannerUrl" alt="avatar" />
                </template>
                <template v-if="column.dataIndex === 'link'">
                  {{ record.link }}
                </template>
                <template v-if="column.dataIndex === 'action'">
                  <a-space size="small">
                    <a-button type="primary" @click="editBanner(record)">
                      编辑
                    </a-button>
                    <!-- 删除 -->
                    <a-popconfirm title="删除后不可恢复，确认删除?" ok-text="是" cancel-text="否" @confirm="handleDelete(record.id)">
                      <a-button type="primary" danger>
                        删除
                      </a-button>
                    </a-popconfirm>
                  </a-space>
                </template>
              </template>
            </a-table>

          </a-layout-content>

        </a-tab-pane>
      </a-tabs>

    </a-layout>

    <!-- 文章序号修改，弹出框 -->
    <a-modal title="文章序号" v-model:open="modalArticleVisible" :confirm-loading="modalLoading" @ok="handleModalOk">
      <a-form :model="recommend" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="序号">
          <a-input v-model:value="recommend.sort" :allowClear="true" type="number" min="1" placeholder="请输入序号" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 模态弹出框-->
    <a-modal title="轮播图表单" v-model:open="modalBannerVisible" :confirm-loading="modalLoading" @ok="handleModalOk">
      <a-form :model="recommend" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
        <a-form-item label="图片">
          <a-input v-model:value="recommend.banner" :disabled="true" :allowClear="true" />
          <!-- 上传控件 -->
          <!-- ！！！注意 name中的file要和后台 @RequestBody MultipartFile file 中的file同名 ！！！ -->
          <a-upload v-model:file-list="fileList" name="file" list-type="picture-card" class="avatar-uploader"
            :show-upload-list="false" :action="SERVER + '/file/upload/avatar'" :before-upload="beforeUpload"
            :headers="uploadHeaders" @change="handleChange">
            <template v-if="imageUrl">
              <img :src="imageUrl" alt="avatar" />
            </template>
            <template v-else>
              <div>
                <loading-outlined v-if="coverLoading"></loading-outlined>
                <plus-outlined v-else></plus-outlined>
                <div class="ant-upload-text">上传</div>
              </div>
            </template>
          </a-upload>
        </a-form-item>

        <a-form-item label="链接">
          <a-input v-model:value="recommend.link" :allowClear="true" placeholder="请输入链接url" />
        </a-form-item>
        <a-form-item label="序号">
          <a-input v-model:value="recommend.sort" :allowClear="true" type="number" min="1" placeholder="请输入序号" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 底部 -->
    <TheFooter></TheFooter>

  </a-layout>


</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from 'vue';
import axios from 'axios';
import { message } from 'ant-design-vue';
import { Tool } from "@/util/tool";
import store from "@/store";
import TheFooter from "@/components/the-footer.vue";


export default defineComponent({
  name: 'AdminRecommend',
  components: {
    TheFooter
  },
  setup() {
    const param = ref();
    param.value = {};
    const loading = ref(false);
    const activeKey = ref('1');

    //--------------------文章列表--------------------
    const articles = ref();
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0
    });
    const columns = [
      {
        title: '排序',
        dataIndex: 'sort',
        width: 80
      },
      {
        title: '封面',
        dataIndex: 'coverUrl',
      },
      {
        title: '标题',
        dataIndex: 'title'
      },
      {
        title: '分类',
        dataIndex: 'category',
      },
      {
        title: '描述',
        dataIndex: 'description'
      },
      // {
      //   title: '摘要',
      //   dataIndex: 'summary'
      // },
      {
        title: '阅读数',
        dataIndex: 'viewCount',
        width: 80
      },
      {
        title: '点赞数',
        dataIndex: 'voteCount',
        width: 80
      },
      {
        title: '发布状态',
        dataIndex: 'status',
      },
      {
        title: 'Action',
        dataIndex: 'action',
      }
    ];

    //--------------------轮播图列表--------------------
    const banners = ref();
    const paginationBanner = ref({
      current: 1,
      pageSize: 10,
      total: 0
    });
    const columnsBanner = [
      {
        title: '排序',
        dataIndex: 'sort',
        width: 80
      },
      {
        title: '轮播图',
        dataIndex: 'bannerUrl',
      },
      {
        title: '链接',
        dataIndex: 'link'
      },
      {
        title: 'Action',
        dataIndex: 'action',
      }
    ];

    /**
     * 数据查询 - 文章列表
     **/
    const handleQueryArticle = (params: any) => {
      loading.value = true;
      // 如果不清空现有数据，则编辑保存重新加载数据后，再点编辑，则列表显示的还是编辑前的数据
      articles.value = [];
      // 处理分类选择
      console.log('params', params)
      console.log('type', activeKey.value)

      axios.post("/recommend/list", {
        // 后台Get方法参数
        // params: {}

        // 后台Post方法参数
        page: params.page,
        size: params.size,
        type: 1,   // 类型：1 - 推荐文章  2 - 轮播图
      }).then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          articles.value = result.data.list;
          console.log('articles', articles.value)
          // 重置分页按钮
          pagination.value.current = params.page;
          pagination.value.total = result.data.total;
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 表格点击页码时触发
     */
    const handleTableChange = (pagination: any) => {
      //{current: 2, pageSize: 2, total: 5}
      console.log("自带的分页参数：", pagination);
      // 查询数据
      handleQueryArticle({
        page: pagination.current,
        size: pagination.pageSize
      });
    };

    /**
    * 数据查询 - 轮播图列表
    **/
    const handleQueryBanner = (params: any) => {
      loading.value = true;
      // 如果不清空现有数据，则编辑保存重新加载数据后，再点编辑，则列表显示的还是编辑前的数据
      banners.value = [];
      // 处理分类选择
      console.log('params', params)
      console.log('type', activeKey.value)

      axios.post("/recommend/list", {
        // 后台Get方法参数
        // params: {}

        // 后台Post方法参数
        page: params.page,
        size: params.size,
        type: 2,   // 类型：1 - 推荐文章  2 - 轮播图
      }).then((response) => {
        loading.value = false;
        const result = response.data;
        if (result.code == 0 && result.message == 'success') {
          banners.value = result.data.list;
          console.log('banners', banners.value)
          // 重置分页按钮
          paginationBanner.value.current = params.page;
          paginationBanner.value.total = result.data.total;
        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 表格点击页码时触发
     */
    const handleBannerTableChange = (pagination: any) => {
      //{current: 2, pageSize: 2, total: 5}
      console.log("自带的分页参数：", pagination);
      // 查询数据
      handleQueryBanner({
        page: pagination.current,
        size: pagination.pageSize
      });
    };


    // ------------------------ 表单 ------------------------
    /**
     * 数组，[100, 101]对应：前端开发 / Vue
     */
    const recommend = ref();
    const modalArticleVisible = ref(false);
    const modalBannerVisible = ref(false);
    const modalLoading = ref(false);
    const handleModalOk = () => {
      console.log('recommend', recommend.value)

      // 根据不同类型校验
      if (activeKey.value == '1') {
        if (recommend.value.sort == undefined) {
          message.warning('请补全数据')
          return
        }
        // 新增时候需要补全type
        recommend.value.type = 1
      } else if (activeKey.value == '2') {
        if (recommend.value.sort == undefined
          || recommend.value.link == undefined || recommend.value.link.trim() == ''
          || recommend.value.banner == undefined || recommend.value.banner.trim() == '') {
          message.warning('请补全数据')
          return
        }
        // 新增时候需要补全type
        recommend.value.type = 2
      }

      modalLoading.value = true;

      axios.post("/recommend/save", recommend.value).then((response) => {
        modalLoading.value = false;
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          modalArticleVisible.value = false;
          modalBannerVisible.value = false;
          message.success('提交成功')
          // 重新加载列表
          if (activeKey.value == '1') {
            handleQueryArticle({
              page: pagination.value.current,
              size: pagination.value.pageSize,
            });
          } else if (activeKey.value == '2') {
            handleQueryBanner({
              page: paginationBanner.value.current,
              size: paginationBanner.value.pageSize,
            })
          }

        } else {
          message.error(result.message);
        }
      });
    };

    /**
     * 编辑文章
     */
    const editArticle = (record: any) => {
      console.log('edit article', record)
      recommend.value = Tool.copy(record);
      modalArticleVisible.value = true;
      modalLoading.value = false;
    };


    /**
     * 增加轮播图
     */
    const addBanner = () => {
      console.log('add banner')
      // 清空数据
      recommend.value = {}
      modalBannerVisible.value = true
      modalLoading.value = false
      imageUrl.value = ''
    }

    /**
     * 编辑轮播图
     */
    const editBanner = (record: any) => {
      console.log('edit banner', record)
      recommend.value = Tool.copy(record);
      modalBannerVisible.value = true;
      modalLoading.value = false;
      //修改图像url
      imageUrl.value = recommend.value.bannerUrl
    };


    /**
     * 删除
     * @param id
     */
    const handleDelete = (id: number) => {
      axios.delete("/recommend/delete/" + id).then((response) => {
        const result = response.data; // data = commonResp
        if (result.code == 0 && result.message == 'success') {
          message.success('删除成功')
          // 重新加载列表
          if (activeKey.value == '1') {
            handleQueryArticle({
              page: pagination.value.current,
              size: pagination.value.pageSize,
            });
          } else if (activeKey.value == '2') {
            handleQueryBanner({
              page: paginationBanner.value.current,
              size: paginationBanner.value.pageSize,
            })
          }

        } else {
          message.error(result.message);
        }
      });
    };


    // ------------------------ 上传 ------------------------
    const SERVER = process.env.VUE_APP_SERVER;
    const fileList = ref([]);
    const coverLoading = ref<boolean>(false);
    const imageUrl = ref<string>('');
    const uploadHeaders = ref({});

    const handleChange = (info: any) => {
      console.log('upload info', info)
      // status: 'done', // 状态有： uploading done error removed

      // 正在上传文件
      if (info.file.status === 'uploading') {
        coverLoading.value = true;
        return;
      }

      // 上传完毕
      if (info.file.status === 'done') {

        /**
         * 上传成功，服务器返回
         * {
            "code": 0,
            "message": "success",
            "data": {
                "fileName": "68a720e35de14ca8a926dbe3fcb2b344.png",
                "fileUrl": "http://localhost:8080/wiki-biz/images/68a720e35de14ca8a926dbe3fcb2b344.png"
            }
          }
         */
        let result = info.file.response
        console.log('result', result)
        coverLoading.value = false;
        if (result.code == 0 && result.message == 'success') {
          // 修改文件名
          recommend.value.banner = result.data.fileName
          // 修改图片链接
          imageUrl.value = result.data.fileUrl
        } else {
          message.error(result.message)
        }
      }

      // 上传出错
      if (info.file.status === 'error') {
        coverLoading.value = false;
        message.error('upload error');
      }
    };


    const beforeUpload = (file: any) => {
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
      if (!isJpgOrPng) {
        message.error('只能上传JPG/PNG文件!');
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        message.error('图片必须小于2MB!');
      }
      // 修改请求头，携带token
      console.log('user => ', store.state.user)
      uploadHeaders.value = { "blog-token": store.state.user.token }

      return isJpgOrPng && isLt2M;
    };

    onMounted(() => {

      // 加载文章列表
      handleQueryArticle({
        page: 1,
        size: pagination.value.pageSize,
      });

      handleQueryBanner({
        page: 1,
        size: paginationBanner.value.pageSize,
      })

    });

    return {
      activeKey,
      param,
      articles,
      pagination,
      columns,
      loading,
      editArticle,
      handleTableChange,
      handleQueryArticle,
      modalArticleVisible,
      modalBannerVisible,
      recommend,
      handleModalOk,
      modalLoading,
      handleDelete,

      banners,
      paginationBanner,
      columnsBanner,
      handleQueryBanner,
      handleBannerTableChange,
      editBanner,
      addBanner,

      fileList,
      coverLoading,
      imageUrl,
      handleChange,
      beforeUpload,
      uploadHeaders,
      SERVER
    }
  }
});
</script>

<style scoped>
img {
  width: 50px;
  height: 50px;
}
</style>
